<template>
	<div class="loading">
		<div class="icon">
			<p class="">{{percent}}%</p>
		</div>

	</div>
</template>
<script>
export default {
	created() {},
	data() {
		return {
			loaded: 0,
			total: 0,
		};
	},
	mounted() {
		// var imgs = document.getElementsByTagName("img");

		var imgs = [];
		// console.log($("body *"));
		$("body *").each((item, el) => {
			let tag = el.tagName.toLowerCase();
			let bg = $(el)
				.css("backgroundImage")
				.replace(/url\(('|")/gi, "")
				.replace(/('|")\)/gi, "");
			if (tag == "img" && el.src) {
				imgs.push(el.src);
			}
			if (bg && bg != "none") {
				imgs.push(bg);
			}
		});
		this.total = imgs.length;
		if (this.total == 0) {
			this.$emit("loaded");
			return;
		}

		imgs.map((src) => {
			let item = new Image();

			item.onload = () => {
        this.loaded++;
				console.log(this.loaded);
			};
			item.onerror = () => {
				this.loaded++;
			};

			item.src = src;
		});
	},
	computed: {
		percent() {
			if (this.total == 0) {
				return 0;
			}
			var percent = parseInt((this.loaded / this.total) * 100);
			if (percent >= 100) {
				this.$emit("loaded");
			}
			return percent;
		},
	},
};
</script>
<style scoped>
.loading {
	background: #00176a url("../assets/bg2.jpg") no-repeat center/cover;
	width: 100%;
	height: 100%;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 99999;
	transition: all 0.3s;
}
.icon {
	width: 1.8rem;
	height: 1.8rem;
	background: url("../assets/loading_icon.png") no-repeat center/contain;
	position: absolute;
	left: 50%;
	top: 50%;
	margin-left: -0.9rem;
	margin-top: -0.9rem;
	animation: huxi3 1s ease-in-out 0s infinite alternate-reverse both;
}
p {
	text-align: center;
	font-size: 0.18rem;
	color: #78d1fa;
	position: absolute;
	bottom: 0;
	width: 100%;
}
</style>